
import api from './api';

const endpoint = '/api/despesas';

const DespesasService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },
    
  getAtivas: async () => {
    const response = await api.get(`${endpoint}/ativas`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },


  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default DespesasService;